// extracted by mini-css-extract-plugin
export default {"box":"_c0559963","shareLink":"_6837c57b","title":"_e4a69216","linkBox":"_5ee82043","url":"_23c0829d","linkCopyMobile":"_ff582413"};